import React from 'react';
import { Container, Popover, Button, TextField, Box, Typography } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

import { AlertingComponent } from 'react-frontend-utils';

export class GenericPassRequestPopup extends AlertingComponent {

    styles = {
        button: {
            marginLeft: 10,
            marginRight: 10
        },
        container: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        }
    };

 
    _okCallback;
    _cancelCallback;

    constructor(props) {
        super(props);
        this._okCallback = props.okCallback;
        this._cancelCallback = props.cancelCallback;
        this.state.community = null;
        this.state.communityValue = "";
        this.state.startingBarcode = "";
        this.state.numberRequested = "";
    }

    _startingBarcodeChanged = (event) => {
        const raw = event.target.value;
        if (raw === "") {
            this.setState({startingBarcode: ""});
            return;
        }

        const val = Math.max(0, parseInt(raw, 10));
        this.setState({startingBarcode: Number.isNaN(val) ? "" : val.toString()});
    }

    _numberRequestedChanged = (event) => {
        const raw = event.target.value;
        if (raw === "") {
            this.setState({numberRequested: ""});
            return;
        }

        const val = Math.min(1000, Math.max(1, parseInt(raw, 10)));
        this.setState({numberRequested: Number.isNaN(val) ? "" : val.toString()});
    }

    _okButtonPressed = () => {
        const startingBarcode = parseInt(this.state.startingBarcode, 10);
        const numberRequested = parseInt(this.state.numberRequested, 10);

        this._okCallback(this.state.community, startingBarcode, numberRequested);

        this.setState({
            community: null,
            communityValue: "",
            startingBarcode: "",
            numberRequested: ""
        });
    }
    
    _cancelButtonPressed = () => {
        this._cancelCallback();
        this.setState({
            community: null,
            communityValue: "",
            startingBarcode: "",
            numberRequested: ""
        });
    }

    
    render() {
        
        let maxWidth = window.innerWidth * 0.5;
        if (maxWidth > 700)
            maxWidth = 700;

        const okDisabled = !this.state.community || this.state.startingBarcode === "" || this.state.numberRequested === "";

        return (
            <Popover open={this.props.isOpen} 
                anchorReference="anchorPosition"
                anchorPosition={{left: window.innerWidth/2, top: window.innerHeight/2}}
                transformOrigin={{vertical: 'center', horizontal: 'center'}}  >

                <Box style={{margin: 20, width: maxWidth}}>
                    <Typography variant="subtitle1" style={{fontWeight: 'bold', marginBottom: 20}}>Generic Pass Request</Typography>


                    <Autocomplete
                        size='small'
                        value={this.state.community}
                        onChange={(event, newValue) => { this.setState({community: newValue}); }}
                        inputValue={this.state.communityValue}
                        onInputChange={(event, newValue) => { this.setState({communityValue: newValue}); }}
                        options={this.props.communities}
                        getOptionLabel={(val) => val.name}
                        blurOnSelect
                        renderInput={(params) => <TextField {...params} label="Community" variant="outlined" InputLabelProps={{ shrink: true }} />}
                    />

                    <div style={{marginTop: 20}}/>

                    <Container style={{...this.styles.container, justifyContent: 'space-between', marginBottom: 20, gap: 20}}>
                        <TextField
                            label="Starting Barcode"
                            type="number"
                            value={this.state.startingBarcode}
                            onChange={this._startingBarcodeChanged}
                            variant="outlined"
                            fullWidth={true}
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ min: 0, step: 1 }}
                        />

                        <TextField
                            label="Number Requested"
                            type="number"
                            value={this.state.numberRequested}
                            onChange={this._numberRequestedChanged}
                            variant="outlined"
                            fullWidth={true}
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ min: 1, max: 1000, step: 1 }}
                        />
                    </Container>
        
                    <Container style={this.styles.container}>    
                        <Button onClick={this._okButtonPressed} disabled={okDisabled} color="primary" variant="outlined" style={this.styles.button}>OK</Button>
                        <Button onClick={this._cancelButtonPressed} variant="outlined" style={this.styles.button}>Cancel</Button>
                    </Container>
                </Box>
            </Popover>
        );
        
        
    }


}